import {
  IDataSource,
  IDataSourceFilter,
  IPaginationFilters,
  IMessagePayload,
  dataSourcesInfo,
  Loading,
} from "@dataone/lib";
import { Input, Space, Avatar } from "antd";
import { css, styled } from "styled-components";
import { useRef, useState } from "react";
import EntrepriseConnectorsList from "../enterprise-connectors/EntrepriseConnectorsList";
import { useEffect } from "react";
import DatasourceDefaultChatMessage from "./DatasourceDefaultChatMessage";
interface DefaultChatMessageProps {
  stepRef7: React.MutableRefObject<null>;
  selectedOption: number;
  setMessagePayLoad: (message: IMessagePayload) => void;
  messagePayLoad: IMessagePayload;
  datasources?: Required<IDataSource>[];
  isOpen?: boolean;
  setSelectedDatabase?: (database: IDataSource) => void;
  setSelectedDatasources: React.Dispatch<
    React.SetStateAction<dataSourcesInfo[]>
  >;
  selectedDatasources: dataSourcesInfo[];
  setDatasetsFilters?: React.Dispatch<
    React.SetStateAction<IPaginationFilters<IDataSourceFilter, IDataSource>>
  >;
  // datasourceIsLoading?: boolean;
  // datasources?: IDataSource[];
  IsLoading?: boolean;
  datasetsFilters?: IPaginationFilters<IDataSourceFilter, IDataSource>;
}
const DefaultChatMessage = ({
  stepRef7,
  selectedOption,
  setMessagePayLoad,
  messagePayLoad,
  datasources,
  isOpen,
  setSelectedDatabase,
  setSelectedDatasources,
  selectedDatasources,
  setDatasetsFilters,
  // datasourceIsLoading,
  // datasources,
  IsLoading,
  datasetsFilters,
}: DefaultChatMessageProps) => {
  const [databasesList, setDatabasesList] = useState<IDataSource[]>(
    datasources || []
  );
  const handleNext = () => {
    setDatabasesList((prev) => {
      const [first, ...rest] = prev;
      return [...rest, first];
    });
  };

  useEffect(() => {
    setDatabasesList(datasources || []);
  }, [datasources]);

  const handlePrev = () => {
    setDatabasesList((prev) => {
      const last = prev[prev.length - 1];
      const rest = prev.slice(0, prev.length - 1);
      return [last, ...rest];
    });
  };
  const OGMessage = () => {
    return (
      <p>
        Hi , this is <span>OG </span>! may i be helpful for you today , i can
        help you quickly get what you search for .
      </p>
    );
  };
  const OGDataMessage = () => {
    return (
      <p>
        Hi , this is <span>OG </span>! Please select the data sources you'd like
        to work with.
      </p>
    );
  };
  const handleSelectDatabase = (database: IDataSource) => {
    setSelectedDatabase?.(database);
    setMessagePayLoad &&
      database.id &&
      setMessagePayLoad({ ...messagePayLoad, databaseId: database.id });
  };
  // const handleShowArrows = () => {
  //   console.log(
  //     document.getElementById("left-arrow")?.getBoundingClientRect().left
  //   );
  //   // document.getElementById("left-arrow")?.classList.add("show-arrow");
  // };

  const listDatabases = () => {
    return (
      <div
        ref={containerRef}
        style={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "50px",
          overflow: "hidden",
        }}
      >
        {databasesList?.map((database: IDataSource, index) => (
          <StyledAvatar
            $active={database.id === messagePayLoad.databaseId ? true : false}
            key={index}
            // {...(index === databasesList.length - 1 && handleShowArrows)}
            // index === databasesList.length - 1 (condition of this is th elast element)
            // eleme
          >
            <Avatar
              shape="square"
              size={54}
              icon={
                <img
                  alt="dataset"
                  src={`images/data-management/datasources_icons/icon-${
                    database.internalType === "MYSQL"
                      ? "mysql"
                      : database.internalType === "SQLSERVER"
                      ? "sql-server"
                      : database.internalType === "MONGODB"
                      ? "mongodb"
                      : database.internalType === "POSTGRESQL"
                      ? "postgresql"
                      : database.internalType === "ELASTICSEARCH"
                      ? "elasticsearch"
                      : "oracle"
                  }.svg`}
                />
              }
              onClick={() => {
                handleSelectDatabase(database);
              }}
            />
            <span>{database.displayName}</span>
          </StyledAvatar>
        ))}
      </div>
    );
  };

  const handleWebsiteChange = (e: any) => {
    const website = e.target.value.trim();
    // setUrl && setUrl(website);
    if (website !== "") {
      setMessagePayLoad &&
        setMessagePayLoad({ ...messagePayLoad, website: e.target.value });
    } else {
      setMessagePayLoad &&
        setMessagePayLoad({ ...messagePayLoad, website: "" });
    }
  };

  const containerRef = useRef<HTMLDivElement>(null);

  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    // const handleResize = () => {
    if (container) {
      const lastItem = container.lastChild as HTMLElement;
      if (lastItem) {
        const lastItemRect = lastItem.getBoundingClientRect();
        setShowArrows(
          lastItemRect.right - 1 > container.getBoundingClientRect().right
        );
      }
    }
    // };

    // handleResize();

    // const eventListener = () => {
    //   handleResize();
    // };

    // window.addEventListener("yourCustomResizeEvent", eventListener);

    // return () => {
    //   window.removeEventListener("yourCustomResizeEvent", eventListener);
    // };
  });

  // const showArrows = containerSize < databasesList.length * 93.19; // Adjust itemWidth based on your styling
  return (
    <>
      <DefaultDiv $isOpen={isOpen || false}>
        <div className="cube">
          <img src={"images/smart-search/chat/OG.gif"} alt="OG" />
        </div>
        <StyledContent ref={stepRef7}>
          {selectedOption === 2 ? (
            <StyledDescription>
              <OGMessage />
            </StyledDescription>
          ) : selectedOption === 5 ? (
            <StyledDescription>
              <OGMessage />
              <StyledSupDescription>
                Please enter embed code start Consulting
              </StyledSupDescription>
              <EntrepriseConnectorsList
                messagePayLoad={messagePayLoad}
                setMessagePayLoad={setMessagePayLoad}
              />
            </StyledDescription>
          ) : selectedOption === 3 ? (
            <StyledDescription>
              <OGMessage />
              <StyledSupDescription>
                Please enter your the website URL and start Consulting
              </StyledSupDescription>
              <img alt="url" src="images/smart-search/chat/url-btn.svg" />
              <Input
                maxLength={255}
                placeholder="Your URL"
                value={messagePayLoad.website}
                onChange={handleWebsiteChange}
                // suffix={
                //   <img
                //     src={"/images/smart-search/document/check-icon-blue.svg"}
                //     alt="check icon"
                //   />
                // }
              />
            </StyledDescription>
          ) : selectedOption === 1 ? (
            // <StyledDescriptionSearchByData>
            //   {/* <OGMessage /> */}
            //   <StyledSupDescription>
            //     Select the data sources you'd like to work with.
            //   </StyledSupDescription>
            //   {/* <StyledList>
            //     {showArrows && (
            //       <img
            //         id="left-arrow"
            //         alt="left"
            //         src="images/smart-search/chat/left-arrow-icon.svg"
            //         onClick={handlePrev}
            //       />
            //     )}

            //     {listDatabases()}

            //     {showArrows && (
            //       <img
            //         alt="right"
            //         src="images/smart-search/chat/right-arrow-icon.svg"
            //         onClick={handleNext}
            //       />
            //     )}
            //   </StyledList> */}

            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // </StyledDescriptionSearchByData>
            // <DatasourceDefaultChatMessage
            //   setSelectedDatasources={setSelectedDatasources}
            //   selectedDatasources={selectedDatasources}
            //   setDatasetsFilters={setDatasetsFilters}
            //   datasources={datasources}
            //   // datasourceIsLoading={datasourceIsLoading}
            //   IsLoading={IsLoading}
            //   datasetsFilters={datasetsFilters}
            // />
            <StyledDescription>
              <OGDataMessage />
            </StyledDescription>
          ) : (
            <>
              <StyledDescriptionSearchByData>
                <OGMessage />
                <StyledSupDescription>
                  What dataset you wish consulting today ?
                </StyledSupDescription>
                <StyledList>
                  {databasesList.length > 4 && (
                    <img
                      alt="left"
                      src="images/smart-search/chat/left-arrow-icon.svg"
                      onClick={handlePrev}
                    />
                  )}
                  {listDatabases()}
                  {databasesList.length > 4 && (
                    <img
                      alt="right"
                      src="images/smart-search/chat/right-arrow-icon.svg"
                      onClick={handleNext}
                    />
                  )}
                </StyledList>
              </StyledDescriptionSearchByData>
              <StyledDescription>
                <img alt="url" src="images/smart-search/chat/url-btn.svg" />
                <Input
                  placeholder="Your URL"
                  maxLength={255}
                  onChange={handleWebsiteChange}
                />
              </StyledDescription>
            </>
          )}
        </StyledContent>
      </DefaultDiv>
    </>
  );
};

export default DefaultChatMessage;

const DefaultDiv = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  background: #fff;
  padding: 5px;
  margin-top: 10px;
  .cube {
    margin-right: 15px;
    margin-top: 14px;
    img {
      width: 30px;
    }
  }
  ${(props) =>
    props.$isOpen &&
    css`
      border-radius: Opx;
      box-shadow: none;
      margin-top: 0px;
    `}
`;

const StyledContent = styled.div`
  width: 89%;
  padding-top: 5px;
  .desc-div {
    color: #040726;
    font-size: 17px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: -0.3px;
    span {
      font-weight: 700;
    }
  }
  .qst-div {
    color: #4974f6;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.24px;
    line-height: 21px;
  }
`;
const StyledDescription = styled.div`
  position: relative;
  color: #040726;
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.3px;
  span {
    font-weight: 700;
  }
  .ant-input {
    border-radius: 26.5px;
    background: #eff1fd;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
    height: 40px;
    font-size: 16px;
    padding-left: 53px;
    margin-bottom: 15px;
  }
  .ant-input:hover {
    border-color: #d9d9d9 !important;
  }
  .ant-input:focus {
    border-color: #d9d9d9 !important;
  }
  img {
    position: absolute;
    z-index: 1;
    height: 40px;
  }
`;

const StyledDescriptionSearchByData = styled.div`
  position: relative;
  color: #040726;
  font-size: 17px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.3px;
  span {
    font-weight: 700;
  }
  .ant-input-affix-wrapper {
    border: none;
    border-radius: 30px;
    padding: 10px 25px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
    background: #eff1fd;
    height: 40px;
    width: 300px;
    ::placeholder {
      color: "#4974F6";
      font-size: 20px;
      font-weight: 400;
    }
    .ant-input {
      color: rgba(4, 7, 38, 0.75);
      font-size: 16px;
      font-weight: 400;
      letter-spacing: -0.3px;
      background: #eff1fd;
    }
  }
`;

const StyledAvatar = styled.div<{ $active: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  span {
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    width: 57px;
    overflow: hidden;
    white-space: nowrap;
    padding-top: 5px;
  }
  .ant-avatar {
    background: #fff;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    > img {
      display: inline !important;
      height: 26px !important;
      width: auto !important;
    }
  }
  .ant-avatar:hover {
    background: #eff1fd;
    // box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25) inset;
    filter: none;
  }
  ${(props) =>
    props.$active &&
    css`
      .ant-avatar {
        box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25);
        border: 2px solid #4974f6;
        filter: none;
        &:hover {
          background: #fff;
          // box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25) inset;
          filter: none;
        }
      }
    `}
`;
const StyledSpace = styled(Space)`
  flex-wrap: nowrap !important;
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
  // max-width: 634px;
  margin: 0 auto;
`;
const StyledList = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const StyledSupDescription = styled.p`
  line-height: 21px;
`;
const StyledDatasetsList = styled.div``;
